import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

// Configurações otimizadas para upload de arquivos
const supabaseOptions = {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: false
  },
  global: {
    headers: {
      'x-client-info': 'ras-5cpa@1.0.0'
    }
  },
  // Configurações de timeout para uploads
  realtime: {
    timeout: 60000 // 60 segundos
  }
};

export const supabase = createClient(supabaseUrl, supabaseAnonKey, supabaseOptions);

// Função auxiliar para upload com retry e timeout personalizado
export const uploadFileWithRetry = async (bucket, path, file, options = {}) => {
  const maxRetries = 3;
  const timeoutMs = 120000; // 2 minutos
  
  const defaultOptions = {
    cacheControl: '3600',
    upsert: false,
    contentType: file.type,
    ...options
  };

  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      // Criar uma Promise com timeout
      const uploadPromise = supabase.storage
        .from(bucket)
        .upload(path, file, defaultOptions);

      const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error(`Upload timeout após ${timeoutMs / 1000} segundos (tentativa ${attempt}/${maxRetries})`));
        }, timeoutMs);
      });

      const result = await Promise.race([uploadPromise, timeoutPromise]);
      
      if (result.error) {
        throw result.error;
      }
      
      return result;
    } catch (error) {
      console.warn(`Tentativa ${attempt}/${maxRetries} falhou:`, error.message);
      
      if (attempt === maxRetries) {
        throw new Error(`Falha no upload após ${maxRetries} tentativas: ${error.message}`);
      }
      
      // Aguardar antes da próxima tentativa (backoff exponencial)
      await new Promise(resolve => setTimeout(resolve, Math.pow(2, attempt) * 1000));
    }
  }
};